import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { black, brandPrimaryHoverTint, darkGrayFontColor, mention, titles, white } from '../../../../styles/colors';

export const styles = StyleSheet.create({
	modal: {
		position: 'relative' as const,
	},
	modalHeaderCloseButton: {
		position: 'absolute' as const,
		top: 0,
		right: 0,
	},
	modalContainer: {
		padding: THEME.spacing.lg,
		minWidth: 500,
	},
	container: {
		padding: THEME.spacing.lg,
	},
	header: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.md,
		marginBottom: THEME.spacing.xl,
	},
	headerIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
	},
	headerContent: {
		flex: 1,
	},
	title: {
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
		marginBottom: THEME.spacing.sm,
		color: titles,
	},
	description: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
	},
	headerActions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		flexShrink: 0,
	},
	tableWrapper: {
		width: '100%',
		height: '100%',
		overflowX: 'auto',
		overflowY: 'auto',
		background: white,
		maxWidth: '100vw',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	table: {
		width: '100%',
		borderCollapse: 'separate',
		borderSpacing: 0,
		paddingTop: 0,
		paddingBottom: 0,
		border: 0,
	},
	tableHeaderCell: {
		background: brandPrimaryHoverTint,
		minWidth: 150,
		position: 'relative',
	},
	tableHeaderCellActions: {
		textAlign: 'right' as const,
	},
	tableRow: {},
	tableCell: {
		padding: '12px 16px',
		fontSize: 14,
		color: titles,
		verticalAlign: 'middle' as const,
	},
	tableCellActions: {
		padding: '12px 16px',
		textAlign: 'right' as const,
		verticalAlign: 'middle' as const,
	},
	tableCellType: {
		padding: '12px 8px',
		fontSize: 14,
		color: titles,
		verticalAlign: 'middle' as const,
		textAlign: 'left' as const,
	},
	actionButtons: {
		display: 'flex',
		gap: 8,
		justifyContent: 'flex-end',
	},
	emptyState: {
		padding: 40,
		textAlign: 'center' as const,
		color: '#6b7280',
	},
	modalHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: THEME.spacing.lg,
		paddingBottom: THEME.spacing.md,
	},
	modalTitle: {
		fontSize: 18,
		margin: 0,
		color: THEME.colors.primary.main,
	},
	formGroup: {
		marginBottom: THEME.spacing.lg,
	},
	formLabel: {
		display: 'block',
		marginBottom: THEME.spacing.sm,
		fontSize: 14,
		fontWeight: 500,
		color: THEME.colors.text.dark,
	},
	permissionSection: {
		marginBottom: THEME.spacing.lg,
	},
	permissionTitle: {
		fontSize: 14,
		fontWeight: 600,
		marginBottom: THEME.spacing.sm,
		color: '#111827',
	},
	permissionMatrix: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		backgroundColor: white,
	},
	matrixHeader: {
		display: 'grid',
		gridTemplateColumns: '140px repeat(3, 1fr)',
		backgroundColor: mention,
		borderBottom: THEME.common.border,
	},
	matrixHeaderCell: {
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: 11,
		fontWeight: 600,
		textTransform: 'uppercase' as const,
		letterSpacing: 0.5,
		color: black,
		textAlign: 'center' as const,
		borderRight: THEME.common.border,
	},
	matrixHeaderCellFirst: {
		textAlign: 'left' as const,
		fontWeight: 600,
	},
	matrixRow: {
		display: 'grid',
		gridTemplateColumns: '140px repeat(3, 1fr)',
		borderBottom: THEME.common.border,
		':last-child': {
			borderBottom: 'none',
		},
	},
	matrixRowCell: {
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		borderRight: THEME.common.border,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center' as const,
		backgroundColor: white,
	},
	matrixRowCellFirst: {
		justifyContent: 'flex-start' as const,
		fontSize: 14,
		fontWeight: 500,
		color: titles,
		backgroundColor: white,
	},
	modalActions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-start',
		marginTop: THEME.spacing.xl,
		paddingTop: THEME.spacing.md,
	},
	disabledInput: {
		cursor: 'not-allowed',
	},
	tableDataCellDisabled: {
		// @ts-expect-error -- this is a hack to allow the button to show the correct cursor when disabled
		pointerEvents: 'auto !important',
		cursor: 'not-allowed',
	},
});
